<ng-container *ngIf="order else nextOrder">
    <div class="reorder-card-container" role="region" aria-label="Order details">
        <div class="reorder-card-header">
            <a type="button" tabindex="0" class="location text-decoration-none" title="{{order.location.name}}"
               [routerLink]="'/menu/' + (order.location.slugURL ? order.location.slugURL : order.location.locationID)"
               aria-label="Restaurant location: {{order.location.name}}">
                {{order.location.name}}
            </a>
            <div class="price d-flex w-100 m-0">
                <div class="d-flex grow-1">
                    <span aria-label="Order date: {{order.orderReadyTimestamp | date: 'MMMM d, yyyy': order.location.utcOffset}}">
                        {{order.orderReadyTimestamp | date: 'M/d/yyyy': order.location.utcOffset}}
                    </span>
                </div>
                <div>
                    <span aria-label="Order price: {{order.totalCents / 100 | currency: currencyCode}}">
                        {{order.totalCents / 100 | currency: currencyCode}}
                    </span>
                </div>
            </div>
        </div>

        <div class="reorder-card-body">
            <div class="body-contents">
                <div class="order-type">
                    <span aria-label="Order type: {{(handoffs[order.handoffType] === 'dispatch' ? 'delivery' : handoffs[order.handoffType]) | titlecase}}">
                        <ng-container [ngSwitch]="order.handoffType">
                            <ng-container *ngSwitchCase="handoffs.pickup">
                                <ng-container *ngIf="handoffs.pickup | handoffLabel | async as pickupLabel">
                                    {{ (pickupLabel || 'Pickup') | titlecase }}:
                                </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="handoffs.curbside">
                                <ng-container *ngIf="handoffs.curbside | handoffLabel | async as curbsideLabel">
                                    {{ (curbsideLabel || 'Curbside') | titlecase }}:
                                </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="handoffs.delivery">
                                <ng-container *ngIf="handoffs.delivery | handoffLabel | async as deliveryLabel; else tryDispatchReorder">
                                    {{ (deliveryLabel || 'Delivery') | titlecase }}:
                                </ng-container>
                                <ng-template #tryDispatchReorder>
                                    <ng-container *ngIf="handoffs.dispatch | handoffLabel | async as dispatchLabel">
                                        {{ (dispatchLabel || 'Delivery') | titlecase }}:
                                    </ng-container>
                                    <ng-container *ngIf="!(handoffs.dispatch | handoffLabel | async)">
                                        Delivery:
                                    </ng-container>
                                </ng-template>
                            </ng-container>
                            <ng-container *ngSwitchCase="handoffs.dispatch">
                                <ng-container *ngIf="handoffs.dispatch | handoffLabel | async as dispatchLabel; else tryDeliveryReorder">
                                    {{ (dispatchLabel || 'Delivery') | titlecase }}:
                                </ng-container>
                                <ng-template #tryDeliveryReorder>
                                    <ng-container *ngIf="handoffs.delivery | handoffLabel | async as deliveryLabel">
                                        {{ (deliveryLabel || 'Delivery') | titlecase }}:
                                    </ng-container>
                                    <ng-container *ngIf="!(handoffs.delivery | handoffLabel | async)">
                                        Delivery:
                                    </ng-container>
                                </ng-template>
                            </ng-container>
                            <ng-container *ngSwitchCase="handoffs.driveThru">
                                <ng-container *ngIf="handoffs.driveThru | handoffLabel | async as driveThruLabel">
                                    {{ (driveThruLabel || 'Drive-Thru') | titlecase }}:
                                </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="handoffs.dineIn">
                                <ng-container *ngIf="handoffs.dineIn | handoffLabel | async as dineInLabel">
                                    {{ (dineInLabel || 'Dine In') | titlecase }}:
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </span>
                    <div class="badge rounded-pill"
                         [ngClass]="{
                             'bg-success' : order.orderStatus === 'Completed' || order.orderStatus === 'completed',
                             'bg-secondary' : order.orderStatus === 'Canceled',
                             'bg-info' : order.orderStatus === 'in-progress' || order.orderStatus === 'In Progress' || order.orderStatus === 'Transmitting' || order.orderStatus === 'Pending Manual Fire',
                             'bg-light border' : order.orderStatus === 'Scheduled'}"
                         aria-label="Order status: {{order.orderStatus | titlecase}}">
                        {{order.orderStatus | titlecase}}
                    </div>
                </div>
                <div class="">
                    <div class="product" aria-label="Ordered items">
                        <ng-container *ngFor="let item of order.items; first as first; last as last, index as index">
                            {{item.name | truncate: 30 | titlecase}}
                            <ng-container *ngIf="!last && order.items.length > 1">
                                •
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="w-100 d-flex flex-column gap-2 justify-content-end align-items-center">
                <a tabindex="0" type="button" class="show-details" (click)="viewConfirmationClicked($event)" (keydown.enter)="viewConfirmationClicked($event)"
                   role="button" aria-label="View receipt">
                    Receipt
                </a>
                <ng-container
                        *ngIf="!order.isEditable">
                    <button class="order-btn de-primary-btn-sm" (click)="reorderClicked($event)" aria-label="Reorder this order">
                        <ng-container *ngIf="!isLoading">
                            Reorder
                        </ng-container>
                        <ng-container *ngIf="isLoading">
                            <div class="de-btn-loader" aria-label="Loading" role="status" aria-live="polite"></div>
                        </ng-container>
                    </button>
                </ng-container>
                <ng-container
                        *ngIf="order.isEditable">
                    <button class="order-btn de-danger-btn-sm" (click)="cancelOrderClicked($event)" aria-label="Cancel this order">
                        <ng-container *ngIf="!isLoading">
                            Cancel
                        </ng-container>
                        <ng-container *ngIf="isLoading">
                            <div class="de-btn-loader" aria-label="Loading" role="status" aria-live="polite"></div>
                        </ng-container>
                    </button>
                </ng-container>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #nextOrder>
    <div class="reorder-card-container-empty" role="region" aria-label="No orders information">
        <div class="reorder-card-body bg-white text-muted">
            <div class="body-contents">
                <div class="d-flex flex-column align-items-center justify-content-center h-100" style="gap: 0.5rem;">
                    <ng-container *ngIf="theme$ | async as theme">
                        <app-custom-icon class=""
                                         default="bi-receipt-cutoff"
                                         customIconKey="orders_navigation_icon"
                                         size="48"
                                         aria-hidden="true"
                        ></app-custom-icon>
                    </ng-container>
                </div>
                <small class="text-center pb-2">
                    Place an order to start tracking your recent orders
                </small>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #reorderModal let-modal>
    <div class="px-3 pt-3 pb-5" role="dialog" aria-labelledby="reorderModalTitle" aria-modal="true">
        <div class="d-flex justify-content-end w-100">
            <button class="btn p-0 border-0" aria-label="Close dialog" (click)="modal.close()">
                <i class="bi bi-x-circle d-flex pointer" style="font-size: 30px;"></i>
            </button>
        </div>
        <div class="d-flex flex-column gap-3">
            <div class="w-100 modal-heading m-0 header-font">
                <h1 id="reorderModalTitle" class="font-size-h1 m-0 fw-bold text-center">Order History</h1>
            </div>
            <div class="w-100 d-flex justify-content-center">
                <div class="header-underline m-0" aria-hidden="true"></div>
            </div>
            <div class="d-flex flex-row flex-nowrap pt-4 pt-md-0">
                <div class="grow-1 basis-0 d-sm-block d-none"></div>
                <div class="reorder-card-container-modal grow-3 basis-0">
                    <div class="reorder-card-header">
                        <h5 class="location">
                            {{order.location.name}}
                        </h5>
                        <div class="price">
                            <span aria-label="Order date: {{order.orderReadyTimestamp | date: 'MMMM d, yyyy': order.location.utcOffset}}">
                                {{order.orderReadyTimestamp | date: 'M/d/yyyy': order.location.utcOffset}}
                            </span>
                            <span aria-label="Order price: {{order.totalCents / 100 | currency: currencyCode}}">
                                {{order.totalCents / 100 | currency: currencyCode}}
                            </span>
                        </div>
                    </div>
                    <div class="reorder-card-body">
                        <div class="body-contents">
                            <div class="order-type">
                                <span aria-label="Order type: {{(handoffs[order.handoffType] === 'dispatch' ? 'delivery' : handoffs[order.handoffType]) | titlecase}}">
                                    <ng-container [ngSwitch]="order.handoffType">
                                        <ng-container *ngSwitchCase="handoffs.pickup">
                                            <ng-container *ngIf="handoffs.pickup | handoffLabel | async as pickupLabel">
                                                {{ (pickupLabel || 'Pickup') | titlecase }}:
                                            </ng-container>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="handoffs.curbside">
                                            <ng-container *ngIf="handoffs.curbside | handoffLabel | async as curbsideLabel">
                                                {{ (curbsideLabel || 'Curbside') | titlecase }}:
                                            </ng-container>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="handoffs.delivery">
                                            <ng-container *ngIf="handoffs.delivery | handoffLabel | async as deliveryLabel; else tryDispatchReorder">
                                                {{ (deliveryLabel || 'Delivery') | titlecase }}:
                                            </ng-container>
                                            <ng-template #tryDispatchReorder>
                                                <ng-container *ngIf="handoffs.dispatch | handoffLabel | async as dispatchLabel">
                                                    {{ (dispatchLabel || 'Delivery') | titlecase }}:
                                                </ng-container>
                                                <ng-container *ngIf="!(handoffs.dispatch | handoffLabel | async)">
                                                    Delivery:
                                                </ng-container>
                                            </ng-template>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="handoffs.dispatch">
                                            <ng-container *ngIf="handoffs.dispatch | handoffLabel | async as dispatchLabel; else tryDeliveryReorder">
                                                {{ (dispatchLabel || 'Delivery') | titlecase }}:
                                            </ng-container>
                                            <ng-template #tryDeliveryReorder>
                                                <ng-container *ngIf="handoffs.delivery | handoffLabel | async as deliveryLabel">
                                                    {{ (deliveryLabel || 'Delivery') | titlecase }}:
                                                </ng-container>
                                                <ng-container *ngIf="!(handoffs.delivery | handoffLabel | async)">
                                                    Delivery:
                                                </ng-container>
                                            </ng-template>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="handoffs.driveThru">
                                            <ng-container *ngIf="handoffs.driveThru | handoffLabel | async as driveThruLabel">
                                                {{ (driveThruLabel || 'Drive-Thru') | titlecase }}:
                                            </ng-container>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="handoffs.dineIn">
                                            <ng-container *ngIf="handoffs.dineIn | handoffLabel | async as dineInLabel">
                                                {{ (dineInLabel || 'Dine In') | titlecase }}:
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </span>
                                <span aria-label="Order status: {{order.orderStatus | titlecase}}">
                                    {{order.orderStatus | titlecase}}
                                </span>
                            </div>
                            <div class="d-flex flex-column" style="gap: 0.5rem;">
                                <ng-container *ngFor="let item of order.items, index as i">
                                    <ng-container *ngIf="i < 2">
                                        <div class="d-flex flex-column">
                                            <div class="d-flex flex-nowrap gap-3">
                                                <div class="product grow-1">
                                                    {{order.items[0]?.name | truncate: 30}}
                                                </div>
                                                <div>
                                                    <span aria-label="Item price: {{item.totalCents / 100 | currency: currencyCode}}">
                                                        {{item.totalCents / 100 | currency: currencyCode}}
                                                    </span>
                                                </div>
                                            </div>
                                            <ng-container *ngIf="item.options && item.options.length > 0">
                                                <small aria-label="Item options: {{item.options | optionsList}}">{{item.options | optionsList}}</small>
                                            </ng-container>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                        <div class="d-flex flex-column align-items-center pb-2" style="gap: 1rem;">
                            <button class="order-btn de-primary-btn-sm text-center" (click)="reorderClicked($event)" aria-label="Order this meal again">
                                <ng-container *ngIf="!isLoading">
                                    Order Again
                                </ng-container>
                                <ng-container *ngIf="isLoading">
                                    <div class="de-btn-loader" aria-label="Loading" role="status" aria-live="polite"></div>
                                </ng-container>
                            </button>
                            <button class="show-details de-primary-link" (click)="viewConfirmationClicked($event)" aria-label="View order confirmation">
                                View Confirmation
                            </button>
                        </div>
                    </div>
                </div>
                <div class="grow-1 basis-0 d-sm-block d-none"></div>
            </div>
        </div>
    </div>
</ng-template>